import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=0c2658f2&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2658f2')) {
      api.createRecord('0c2658f2', component.options)
    } else {
      api.reload('0c2658f2', component.options)
    }
    module.hot.accept("./ProductList.vue?vue&type=template&id=0c2658f2&", function () {
      api.rerender('0c2658f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductList.vue"
export default component.exports